<template>
  <p class="has-text-grey is-size-7 is-uppercase has-text-weight-semibold m-t-5 m-b-10">
    {{ title }}
  </p>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchFilterHeader',
  props: {
    title: { type: String, required: true }
  }
};
</script>
